export const PORTAL_ROOT_ID = "portal-root";
